export default __webpack_public_path__ + "static/media/isa-bg1.7cfb4103.jpg";